// extracted by mini-css-extract-plugin
var _1 = "More-modulemore__DMaj2 MultiValuedListMoreButton-moduleMultiValuedListMoreButton__uXKl3";
export { _1 as "more" }
